import { v4 } from 'uuid';

export enum NoticeType {
	ALERT = 'alert',
	DIALOG = 'dialog'
}

export enum NoticeClass {
	INFO = 'info',
	ERROR = 'error',
	SUCCESS = 'success'
}

export enum NoticeResponse {
	ACCEPT = 'accept',
	DISMISS = 'dismiss',
	DECLINE = 'decline'
}

export default class Notice {
	id = '';
	protected type!: NoticeType;
	message = '';
	acceptLabel = '';
	dismissable = true;
	callback: Promise<NoticeResponse>;
	resolve!: (value: NoticeResponse | PromiseLike<NoticeResponse>) => void;
	reject!: (reason?: unknown) => void;

	constructor() {
		this.id = v4();
		this.callback = new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}

	getCallback(): Promise<NoticeResponse> {
		return this.callback;
	}

	getType(): NoticeType {
		return this.type;
	}

	accept(): void {
		this.resolve(NoticeResponse.ACCEPT);
	}

	dismiss(): void {
		this.resolve(NoticeResponse.DISMISS);
	}

	setAcceptLabel(label: string): this {
		this.acceptLabel = label;
		return this;
	}

	setDismissable(d: boolean): this {
		this.dismissable = d;
		return this;
	}
}